import { amplitudeLib } from 'freedom-shared';

import { appConfig } from '@/shared/config';
import { sentryModel, useUserStore } from '@/shared/model';

export const withAmplitude = () => {
  amplitudeLib.init(appConfig.AMPLITUDE_API_KEY).catch(err => {
    sentryModel.captureException(
      sentryModel.getReadableError(
        sentryModel.createCustomErrorText(
          sentryModel.errorPrefix.DEFAULT,
          'INIT_AMPLITUDE',
        ),
        err as Error,
      ),
    );
  });
  const userStore = useUserStore();
  userStore
    .getUserId()
    .then(userId => {
      amplitudeLib.setUserId(userId);
    })
    .catch((err: unknown) => {
      sentryModel.captureException(
        sentryModel.getReadableError(
          sentryModel.createCustomErrorText(
            sentryModel.errorPrefix.DEFAULT,
            'SET_USER_AMPLITUDE',
          ),
          err as Error,
        ),
      );
    })
    .finally(() => {
      /**
       * We need to wait for the user to be authorized to fetch the experiment variants
       * Otherwise, the experiment variants will be fetched with the user id as null and it will lead to incorrect variant selection
       */
      amplitudeLib
        .useAmplitudeExperiment()
        .initExperiment(appConfig.AMPLITUDE_DEPLOYMENT_KEY);
    });
};
